module.exports = __webpack_public_path__ + "img/steppi-max.9bdf0a74.png";